// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class DispatchTaxCode {
  readonly id: string;
  readonly taxCodeId: string;
  readonly integrationId: string;
  readonly code: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.taxCodeId = data.taxCodeId === undefined ? NIL_UUID : data.taxCodeId;
    this.integrationId = data.integrationId === undefined ? NIL_UUID : data.integrationId;
    this.code = data.code === undefined ? '' : data.code;
  }

  static zero(): DispatchTaxCode {
    const zeroValues: ExcludeMethodsDeep<DispatchTaxCode> = {
      id: NIL_UUID,
      taxCodeId: NIL_UUID,
      integrationId: NIL_UUID,
      code: '',
    };
    return new DispatchTaxCode(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchTaxCodeWireFormat = {
  id: string;
  taxCodeId: string;
  integrationId: string;
  code: string;
};

type NewDispatchTaxCodeProps = PartialDeep<DispatchTaxCode, { recurseIntoArrays: true }>;
export const NewDispatchTaxCode: (props: NewDispatchTaxCodeProps) => DispatchTaxCode = (props) =>
  new DispatchTaxCode(props);

type NewDispatchTaxCodeFromWireFormatProps = PartialDeep<
  DispatchTaxCodeWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchTaxCodeFromWireFormat: (
  props: NewDispatchTaxCodeFromWireFormatProps,
) => DispatchTaxCode = (props) => new DispatchTaxCode(props);
